
import OrderSummaryLine from 'JS/components/order/OrderSummaryLine.vue';
import { defineComponent, PropType } from 'vue';
import { IAutomotiveWorkOrderLineItem } from 'JS/types/automotive/WorkOrderQuote';

export default defineComponent({
	components: {
		OrderSummaryLine,
	},
	props: {
		item: {
			type: Object as PropType<IAutomotiveWorkOrderLineItem>,
			required: true,
		},
		price: {
			type: String,
			required: true,
		}
	},
});
